<script lang="ts">
	import type { Snippet } from "svelte";

	interface Props {
		children?: Snippet;
	}

	let { children }: Props = $props();
</script>

<blockquote>
	<div class="inner">
		{@render children?.()}
	</div>
</blockquote>

<style>
	.inner {
		position: relative;
		padding-left: var(--s-4);
	}

	.inner::before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 0.5rem;
		background-color: var(--lysning);
		border-radius: var(--s-1);
	}
</style>
